import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=55ac0374"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ac0374')) {
      api.createRecord('55ac0374', component.options)
    } else {
      api.reload('55ac0374', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=55ac0374", function () {
      api.rerender('55ac0374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/component/checkbox.vue"
export default component.exports